import { render } from "./CornerCellComponent.vue?vue&type=template&id=129e711a"
import script from "./CornerCellComponent.vue?vue&type=script&lang=js"
export * from "./CornerCellComponent.vue?vue&type=script&lang=js"

import "./CornerCellComponent.vue?vue&type=style&index=0&id=129e711a&lang=scss"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__